/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Injector, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import {HosBaseService} from "./hos-base.service";

import { Observable }                                        from 'rxjs';

import { ItemRequestBody } from '../model/itemRequestBody';
import { Playlist } from '../model/playlist';
import { PlaylistItemIdRequestBody } from '../model/playlistItemIdRequestBody';
import { PlaylistNameRequestBody } from '../model/playlistNameRequestBody';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PlaylistsService extends HosBaseService {

    // protected basePath = 'https://localhost';
    // public defaultHeaders = new HttpHeaders();
    // public configuration = new Configuration();

    /*constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }*/

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /*private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }*/


    /**
     * Add a playlist item to the playlist
     * 
     * @param playlistId The playlist id
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addItemToPlaylist(playlistId: number, body?: ItemRequestBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addItemToPlaylist(playlistId: number, body?: ItemRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addItemToPlaylist(playlistId: number, body?: ItemRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addItemToPlaylist(playlistId: number, body?: ItemRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playlistId === null || playlistId === undefined) {
            throw new Error('Required parameter playlistId was null or undefined when calling addItemToPlaylist.');
        }


        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.getBasePath()}/api/v1/playlists/${encodeURIComponent(String(playlistId))}/add`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a playlist
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPlaylist(body?: PlaylistNameRequestBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public createPlaylist(body?: PlaylistNameRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public createPlaylist(body?: PlaylistNameRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public createPlaylist(body?: PlaylistNameRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.getBasePath()}/api/v1/playlists`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the playlist detail
     * 
     * @param playlistId The playlist id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlaylistDetail(playlistId: number, observe?: 'body', reportProgress?: boolean): Observable<Playlist>;
    public getPlaylistDetail(playlistId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Playlist>>;
    public getPlaylistDetail(playlistId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Playlist>>;
    public getPlaylistDetail(playlistId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playlistId === null || playlistId === undefined) {
            throw new Error('Required parameter playlistId was null or undefined when calling getPlaylistDetail.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Playlist>(`${this.getBasePath()}/api/v1/playlists/${encodeURIComponent(String(playlistId))}`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the playlists
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlaylists(observe?: 'body', reportProgress?: boolean): Observable<Array<Playlist>>;
    public getPlaylists(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Playlist>>>;
    public getPlaylists(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Playlist>>>;
    public getPlaylists(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Playlist>>(`${this.getBasePath()}/api/v1/playlists`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove a playlist-item from the playlist
     * 
     * @param playlistId The playlist id
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeItemFromPlaylist(playlistId: number, body?: PlaylistItemIdRequestBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public removeItemFromPlaylist(playlistId: number, body?: PlaylistItemIdRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public removeItemFromPlaylist(playlistId: number, body?: PlaylistItemIdRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public removeItemFromPlaylist(playlistId: number, body?: PlaylistItemIdRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playlistId === null || playlistId === undefined) {
            throw new Error('Required parameter playlistId was null or undefined when calling removeItemFromPlaylist.');
        }


        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.getBasePath()}/api/v1/playlists/${encodeURIComponent(String(playlistId))}/remove`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove the playlist
     * 
     * @param playlistId The playlist id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removePlaylist(playlistId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public removePlaylist(playlistId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public removePlaylist(playlistId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public removePlaylist(playlistId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playlistId === null || playlistId === undefined) {
            throw new Error('Required parameter playlistId was null or undefined when calling removePlaylist.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.getBasePath()}/api/v1/playlists/${encodeURIComponent(String(playlistId))}`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rename the playlist
     * 
     * @param playlistId The playlist id
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public renamePlaylist(playlistId: number, body?: PlaylistNameRequestBody, observe?: 'body', reportProgress?: boolean): Observable<Playlist>;
    public renamePlaylist(playlistId: number, body?: PlaylistNameRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Playlist>>;
    public renamePlaylist(playlistId: number, body?: PlaylistNameRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Playlist>>;
    public renamePlaylist(playlistId: number, body?: PlaylistNameRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playlistId === null || playlistId === undefined) {
            throw new Error('Required parameter playlistId was null or undefined when calling renamePlaylist.');
        }


        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Playlist>(`${this.getBasePath()}/api/v1/playlists/${encodeURIComponent(String(playlistId))}`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reorder the items in the playlist
     * 
     * @param playlistId The playlist id
     * @param body The ordered items
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reorderItemsInPlaylist(playlistId: number, body: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public reorderItemsInPlaylist(playlistId: number, body: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public reorderItemsInPlaylist(playlistId: number, body: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public reorderItemsInPlaylist(playlistId: number, body: Array<number>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playlistId === null || playlistId === undefined) {
            throw new Error('Required parameter playlistId was null or undefined when calling reorderItemsInPlaylist.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling reorderItemsInPlaylist.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.getBasePath()}/api/v1/playlists/${encodeURIComponent(String(playlistId))}/sort`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sync artists in playlist
     * 
     * @param playlistId The playlist id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resyncArtistsInPlaylist(playlistId: number, observe?: 'body', reportProgress?: boolean): Observable<Playlist>;
    public resyncArtistsInPlaylist(playlistId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Playlist>>;
    public resyncArtistsInPlaylist(playlistId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Playlist>>;
    public resyncArtistsInPlaylist(playlistId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playlistId === null || playlistId === undefined) {
            throw new Error('Required parameter playlistId was null or undefined when calling resyncArtistsInPlaylist.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<Playlist>(`${this.getBasePath()}/api/v1/playlists/${encodeURIComponent(String(playlistId))}/artists/resync`,
            null,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sync playlist
     * 
     * @param playlistId The playlist id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resyncPlaylist(playlistId: number, observe?: 'body', reportProgress?: boolean): Observable<Playlist>;
    public resyncPlaylist(playlistId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Playlist>>;
    public resyncPlaylist(playlistId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Playlist>>;
    public resyncPlaylist(playlistId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playlistId === null || playlistId === undefined) {
            throw new Error('Required parameter playlistId was null or undefined when calling resyncPlaylist.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<Playlist>(`${this.getBasePath()}/api/v1/playlists/${encodeURIComponent(String(playlistId))}/resync`,
            null,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
